import type { PropsWithChildren, ReactElement } from "react";

import CustomBasicModal from "app/pages/sales-intelligence/common-components/modals/CustomBasicModal/CustomBasicModal";
import { WIZARD_MODAL_STYLES } from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardModal/styles";

interface WizardModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const WizardModal = ({ isOpen, onClose, children }: PropsWithChildren<WizardModalProps>): ReactElement => {
    return (
        <CustomBasicModal
            isOpen={isOpen}
            onClose={onClose}
            customStyles={WIZARD_MODAL_STYLES}
            shouldCloseOnOverlayClick={false}
        >
            {children}
        </CustomBasicModal>
    );
};

export default WizardModal;
